import http from '@/modules/http'

const QUERY_FIELDS = {
  statuses: 'statuses',
  status: 'status',
  type: 'courseType',
  [FIND_BY_PERSON.patient]: 'filteredPerson',
  [FIND_BY_PERSON.doctor]: 'filteredPerson',
  dates: 'dates',
  device: 'device',
  role: 'userRole'
}

import { FIND_BY_PERSON, DATE_FORMAT } from '@/main.config.js'
import { fullName } from '@/mixins/full-name'

export const pageFiltersInQuery = {
  mixins: [fullName],
  mounted() {
    this.updateWithQuery()
    this.$on('update-query', () => {
      this.loadData()
    })
  },
  computed: {
    query() {
      return !this.$route.query ? null : this.$route.query
    },
    newQuery() {
      let query = Object.assign({}, this.$route.query)

      if (this.statuses) {
        if (this.statuses.length === 0) {
          query.statuses = ''
        } else {
          query.statuses = this.statuses.join('-')
        }
      }

      if (this.status !== undefined && this.status === 0) {
        query.status = ''
      } else if (this.status !== undefined) {
        query.status = this.status
      }

      if (this.userRole && this.userRole !== '0') {
        query.role = this.userRole
      } else if (query.role) {
        delete query.role
      }

      if (this.filteredPerson) {
        if (this.filteredPerson.id) {
          query[this.filteredPerson.findBy] = this.filteredPerson.id
          if (this.filteredPerson.findBy === FIND_BY_PERSON.patient && query[FIND_BY_PERSON.doctor]) {
            delete query[FIND_BY_PERSON.doctor]
          } else if (this.filteredPerson.findBy === FIND_BY_PERSON.doctor && query[FIND_BY_PERSON.patient]) {
            delete query[FIND_BY_PERSON.patient]
          }
        } else {
          if (query[FIND_BY_PERSON.doctor]) {
            delete query[FIND_BY_PERSON.doctor]
          }
          if (query[FIND_BY_PERSON.patient]) {
            delete query[FIND_BY_PERSON.patient]
          }
        }
      }

      if (this.hasFilterRange) {
        query.dates = `${this.dates.startDate.format(DATE_FORMAT.ruShort)}-${this.dates.endDate.format(
          DATE_FORMAT.ruShort
        )}`
      } else if (query.dates) {
        delete query.dates
      }

      if (this.hasSelectedDevise) {
        query.device = this.device.id
      } else if (query.device) {
        delete query.device
      }

      if (this.courseType) {
        query.type = this.courseType
      } else if (query.type) {
        delete query.type
      }

      return query
    }
  },
  methods: {
    updateWithQuery() {
      if (!this.query) {
        return
      }
      // eslint-disable-next-line no-unused-vars
      for (let key in this.query) {
        if (!Object.prototype.hasOwnProperty.call(QUERY_FIELDS, key)) {
          continue
        }

        if (key === 'statuses') {
          this.filterStatusByQuery(key, this.query[key].split('-'))
        } else if (key === FIND_BY_PERSON.doctor || key === FIND_BY_PERSON.patient) {
          this.filterPersonByQuery(key, +this.query[key])
        } else if (key === 'dates') {
          this.filterDatesByQuery(key, this.query[key].split('-'))
        } else if (key === 'device') {
          this.filterDeviceByQuery(key, +this.query[key])
        } else {
          this.$set(this.$data, QUERY_FIELDS[key], +this.query[key])
        }
      }
    },
    filterStatusByQuery(key, statuses) {
      statuses = statuses.filter(s => Object.prototype.hasOwnProperty.call(this.statusList, s))
      this.$set(this.$data, QUERY_FIELDS[key], statuses)
    },
    filterPersonByQuery(key, id) {
      let apiURL = key === FIND_BY_PERSON.patient ? '/patients/' : '/users/'
      http
        .get(apiURL + id, {
          params: {
            $select: ['surname', 'name', 'middle_name', 'id', 'hospital_id']
          }
        })
        .then(response => {
          if (response.data) {
            this.$set(this.$data, QUERY_FIELDS[key], {
              id: response.data.id,
              findBy: key,
              name: this.getSurnameWithInitials(response.data)
            })
            this.$emit('update-query')
          } else {
            this.deleteKeyInQuery(key)
          }
        })
        .catch(() => {
          this.deleteKeyInQuery(key)
        })
    },
    filterDatesByQuery(key, dates) {
      let startDate = this.moment(dates[0], DATE_FORMAT.ruShort)
      let endDate = this.moment(dates[1], DATE_FORMAT.ruShort)

      if (!startDate.isValid() || !endDate.isValid()) {
        this.deleteKeyInQuery(key)
        return
      }
      this.$set(this.$data, QUERY_FIELDS[key], {
        startDate: startDate,
        endDate: endDate
      })
    },
    filterDeviceByQuery(key, id) {
      http
        .get('/devices/' + id, {
          params: {
            $select: ['id', 'serial_number', 'hospital_id']
          }
        })
        .then(response => response.data)
        .then(device => {
          if (device) {
            this.$set(this.$data, QUERY_FIELDS[key], {
              id: device.id,
              serial_number: device.serial_number
            })
            this.$emit('update-query')
          } else {
            this.deleteKeyInQuery(key)
          }
        })
        .catch(() => {
          this.deleteKeyInQuery(key, null)
        })
    },
    updateFullQuery() {
      this.$router.push({
        query: this.newQuery
      })
    },
    addToQuery(key, value) {
      let query = Object.assign({}, this.$route.query, {
        [key]: value
      })
      this.$router.push({
        query: query
      })
    },
    deleteKeyInQuery(key) {
      let query = Object.assign({}, this.$route.query)
      delete query[key]
      this.$router.push({
        query: query
      })
    }
  }
}
